// tslint:disable:promise-function-async (autogenerated)
import BaseAction from '../../components/base/base-action';
import customizationRequests from './customization-requests';

class CustomizationActions extends BaseAction {
    public dispatchEventName: string = 'setCustomizationStoreState';
    private lastRequest: Promise<void>;

    public async getStyles(): Promise<void> {
        this.setProcessing(true);
        const styles = await customizationRequests.fetchStyles();
        this.dispatch({ styles, loaded: true });
        this.setProcessing(false);
    }

    public getStylesIfNotLoaded(): Promise<void> {
        if (!this.lastRequest) {
            this.lastRequest = this.getStyles();
        }
        return this.lastRequest;
    }
}

const actions = new CustomizationActions();
// tslint:disable-next-line:no-default-export (autogenerated)
export default actions;
